import { showLoadingBar, removeLoadingBar } from "./global.js";

var submitForm;
(function($) {
	submitForm = function() {
		showLoadingBar();
		$('button[type="submit"]').find('span').addClass('hidden');
		$('button[type="submit"]').find('svg').removeClass('hidden');
	}
	$(document).on('submit','form',function(e) {
		submitForm();
	});
})(jQuery);


export function resetSubmitBtn() {
	removeLoadingBar();
	$('button[type="submit"]').find('span').removeClass('hidden');
	$('button[type="submit"]').find('svg').addClass('hidden');
}